module.exports = __webpack_public_path__ + "media/assets/silverTag-e5eb7bed3dcdd9aba72b1b99c0c80c2b.png";